export function validateEmail(value?: string) {
  let error;
  if (!value) {
    error = 'Bitte geben Sie eine E-Mail ein.';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Die E-Mail ist nicht gültig.';
  }
  return error;
}
